module.exports = __webpack_public_path__ + "img/1_2-parco-0.2f8cd345.png";